import React from 'react';
import PropTypes from 'prop-types';

const Currency = ({currencies, selectedCurrency, currencySymbols, onChange}) => (
    <div className="currency-select">
        <select id="curr" name="curr" value={selectedCurrency} onChange={onChange}>
            {Object.keys(currencies).map((currency) => (
                <option key={currency} value={currency}>{currencySymbols[currency]}</option>
            ))}
        </select>
    </div>
)

Currency.propTypes = {
    currencies: PropTypes.objectOf(PropTypes.string).isRequired,
    selectedCurrency: PropTypes.string.isRequired,
    currencySymbols: PropTypes.objectOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Currency
